import React, { useEffect } from 'react'

import PageLayout from 'components/layouts/PageLayout'
import SectionLayout from 'components/layouts/SectionLayout'
import BigBanner from 'components/BigBanner'
import CallToActionPHI from 'components/CallToActionPHI'
import StatesCollapse from 'components/StatesCollapse'
import { ourCarriersBannerContent } from './content/ourCarriersBannerContent'
import FirstSection from './content/FirstSection'
import SecondSection from './content/SecondSection'
import SmallBanner from 'components/SmallBanner'
import { FaRegCheckCircle } from "react-icons/fa";
import { NavLink } from "react-router-dom";

function OurCarriers() {

  useEffect(() => {
    // Change Tab Title
    document.title = "Our Carriers - Insurance Enterprise"
  }, [])

  return (
    <>


      <SmallBanner content={ourCarriersBannerContent} />
      <PageLayout
        content={
          <>
            <SectionLayout content={<div className='-mt-14 flex flex-col items-center justify-center'>
              <div>
                <div className='
            text-base text-secondary underline font-bold
            sm:text-lg
            xl:text-xl
      '>
                  We partner with the reputable carriers to provide the best health benefits in the marketplace.
                </div>

                <ul className='text-sm sm:text-base xl:text-lg'>
                  <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 md:mx-2 text-secondary' /> Top-rated health insurance companies in your state</li>
                  <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 md:mx-2 text-secondary' /> More affordable health plans that fit in your budget</li>
                  <li className='flex items-start sm:items-center'><FaRegCheckCircle className='mx-1 md:mx-2 text-secondary' /> Coverage options for individuals, families, and small businesses</li>
                </ul>
              </div>


              <div className='text-base sm:text-lg xl:text-xl font-bold mt-8 mb-2'>
                Find the Best Health Insurance Coverage in Your State! Ask for A Free Quote Today
              </div>

              <div className='
            flex flex-col space-y-2
            sm:flex-row sm:space-y-0 sm:space-x-4
            items-center
      '>

                <NavLink to='/online-quotes'>
                  <button className='
                  btn btn-md btn-secondary text-neutral-content font-bold border-white border-2
                  sm:btn-lg
        '>
                    Individual & Family Health Quote
                  </button>
                </NavLink>

                <NavLink to='/group-health'>
                  <button className='
                  btn btn-md btn-secondary text-neutral-content font-bold border-white border-2
                  sm:btn-lg sm:btn-wide
        '>
                    Group Health Quote
                  </button>
                </NavLink>
              </div>
            </div>} />
            <SectionLayout content={<FirstSection />} />
            <SectionLayout content={<SecondSection />} />
            <SectionLayout content={<StatesCollapse />} background='bg-[#F5ECEC]' />
            <SectionLayout content={<CallToActionPHI />} />
          </>
        }
      />

    </>
  )
}

export default OurCarriers